export const HomeDescription =
  'Plan the perfect group trip, your way. Get an instant personalized itinerary. We handle logistics, payments, and provide a dedicated itinerary, while local experts fine-tune every detail. Enjoy full freedom—without the stress of organizing it all.'

export const MbaExclusiveDescription = HomeDescription
export const ContentCreatorDescription = HomeDescription

export const HomeReasons = [
  {
    title: 'Plan fast.<br/> Personalize faster',
    description:
      'Design your trip in minutes. Personalize instantly. Let our local guides who operate the trip fine-tune the details for you.',
  },
  {
    title: 'Plan your dream trip — for free',
    description:
      'Launch your trip for free. Choose a destination, customize your itinerary, and let local experts handle the details. Operators pay us a small fee for demand.',
  },
  {
    title: 'Travel to over 80 exciting destinations',
    description:
      'Discover amazing places without the stress! With our extensive network, we make it easy for you to plan a memorable experience in 80+ destinations.',
  },
  {
    title: 'Travel for free',
    description:
      'Travel free when you bring 6 or more travelers — this includes everything in the tour except international flights. The requirement of 6 people is subject to change.',
  },
  {
    title: 'Additional revenue stream',
    description:
      'Want to turn your trip into a pay check? Hosts who choose to monetize typically earn $4K-$15K per trip, with top hosts making over $80k per trip.',
  },
  {
    title: 'Flexible and secure payment options',
    description:
      'Travelers can manage payments with flexible options, while we securely handle the collection and disbursement across cities and countries.',
  },
]

export const ContentCreatorReasons = [
  {
    title: 'Plan fast.<br/> Personalize faster',
    description:
      'Design your trip in minutes. Personalize instantly. Let our local guides who operate the trip fine-tune the details for you.',
  },
  {
    title: 'Effortless group travel planning',
    description:
      'Leave the logistics to us—from pricing and payments to on-the-ground support—so you can lead the trip with ease and confidence.',
  },
  {
    title: 'Travel to over 80 exciting destinations',
    description:
      'Discover amazing places without the stress! With our extensive network, we make it easy for you to plan a memorable experience in 80+ destinations.',
  },
  {
    title: 'Leave the details to us. Enjoy the journey',
    description:
      'Focus on creating experiences while we handle vendor coordination and financials, so you can enjoy every moment.',
  },
  {
    title: 'Your personalized booking platform',
    description:
      'Access all trip details in one place! Our platform streamlines communication and keeps everyone informed, easing the load for TourHeroes.',
  },
  {
    title: 'Flexible and secure payment options',
    description:
      'Travelers can manage payments with flexible options, while we securely handle the collection and disbursement across cities and countries.',
  },
]

export const MbaExclusiveReasons = ContentCreatorReasons

export const WellnessDescription =
  'TourHero excels in curating custom wellness retreats, with 1,000+ retreats planned and 500+ venues tailored to support your vision.'

export const WellnessReasons = [
  {
    title: 'No deposits, only discounts',
    description: 'Benefit from group discounts; no upfront payment required.',
  },
  {
    title: 'Destination matching and global logistics network',
    description:
      'Get expert destination matching and complete travel logistics, including meals, hotels, transport, and payments, via our extensive network.',
  },
  {
    title: 'Additional revenue stream',
    description: 'Build your earnings into the price and earn while doing what you love most.',
  },
  {
    title: 'Flexible payment options for your participants',
    description: 'Offer your participants flexible payment options; receive your earnings with a 0% processing fee.',
  },
  {
    title: 'Custom booking page made for you',
    description: 'A tailor-made booking page optimized for web and mobile with all your retreat information.',
  },
  {
    title: 'Travel for free',
    description:
      'With every 6 travelers you bring, you get to travel for free. Please note, the requirement of 6 people is subject to change.',
  },
]
